<template>
  <div class="institutional_management">
    <!-- 选择区域状态 -->
    <div class="status-list">
      <el-tabs
        v-model="activeName"
        v-for="(item, index) in buttonList"
        :key="item + index"
        @tab-click="chouseStatusAction(item.status)"
      >
        <el-tab-pane :label="item.label" :name="String(item.status)"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="status-body">
      <!-- 筛选条件 -->
      <div class="filter-condition">
        <div class="box-left">
          <div class="left_top">
            <span>关键字:</span>
            <div class="filterHospitalTitle" style="display: inline-block">
              <el-input
                v-model="queryParams.keyWord"
                :clearable="true"
                placeholder="请输入机构名称或申请编号"
                @keydown.enter.native="onSubmit"
              />
            </div>
            <span style="margin-left: 18px">选择日期:</span>
            <div class="filterHospitalTitle" style="display: inline-block">
              <el-date-picker
                v-model="filter_date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="dataTimeChangeAction"
                @keydown.enter.native="onSubmit"
                style="width: 250px"
              ></el-date-picker>
            </div>
          </div>
          <div class="left_bottom">
            <el-row>
              <el-col :span="12">
                <span style="margin-right: 6px">地区:</span>
                <province-city-area ref="ityAarea" @provinceCityAreaEmit="provinceCityAreaEmit" />
              </el-col>
              <el-col :span="12">
                <div class="right">
                  <el-button class="filter-button" type="primary" @click="onSubmit">筛选</el-button>
                  <el-button class="filter-button" plain @click="reset">重置</el-button>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <!-- 表格区域 -->
      <div class="table-conter">
        <!-- 列表 -->
        <div class="table-list">
          <el-table
            v-loading="tableLoading"
            :data="tableData"
            :header-cell-style="{
              background: '#fff',
              color: '#303133',
              fontWeight: '100',
              height: '60px',
            }"
          >
            <template slot="empty">
              <div class="table-noData">
                <img
                  class="table-noData-img"
                  src="https://baike-med-1256891581.file.myqcloud.com/2021034/c03485a0-8608-11eb-947c-032fa08bea6e_0.png"
                />
                <div class="table-noData-word">暂无相关内容</div>
              </div>
            </template>
            <el-table-column prop="applyNo" label="申请编号" min-width="17%"></el-table-column>
            <el-table-column label="机构名称" min-width="15%">
              <template slot-scope="scope">
                <div class="orgName" @click="goHospitalDetial(scope.row)">
                  {{ scope.row.orgName }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="provinceName" label="所属省" min-width="8%"></el-table-column>
            <el-table-column prop="cityName" label="所属市" min-width="8%"></el-table-column>
            <el-table-column label="更新日期" min-width="15%">
              <template slot-scope="scope">
                <div>
                  {{
                    scope.row.updatedTime
                      ? parseTime(scope.row.updatedTime, (cFormat = 'yyyy-mm-dd hh:ii:ss'))
                      : ''
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="applicantName" label="申请人" min-width="8%"></el-table-column>
            <el-table-column label="签约状态" min-width="11%">
              <template slot-scope="scope">
                <div>
                  {{
                    scope.row.status === 10
                      ? '待审核'
                      : scope.row.status === 20
                      ? '已通过'
                      : scope.row.status === 30
                      ? '已拒绝'
                      : '已停用'
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="18%">
              <template slot-scope="scope">
                <div style="display: flex">
                  <!-- 图片查看器 -->
                  <el-button type="text" style="font-size: 16px" @click="viewAgreement(scope.row)">
                    查看协议
                  </el-button>
                  <!-- 待审核事件 -->
                  <el-button
                    v-show="scope.row.status === 10"
                    type="text"
                    @click="enable(scope.row, 0)"
                    style="font-size: 16px; margin-left: 10px"
                  >
                    通过
                  </el-button>
                  <el-button
                    v-show="scope.row.status === 10"
                    type="text"
                    @click="AuditRefuse(scope.row)"
                    style="font-size: 16px; margin-left: 10px"
                  >
                    拒绝
                  </el-button>
                  <!-- 已通过 -->
                  <el-button
                    v-show="scope.row.status === 20"
                    type="text"
                    @click="deactivate(scope.row)"
                    style="font-size: 16px"
                  >
                    停用
                  </el-button>
                  <!-- 已拒绝 -->
                  <el-button
                    v-show="scope.row.status === 30"
                    type="text"
                    @click="returnApplication(scope.row)"
                    style="font-size: 16px"
                  >
                    退回申请
                  </el-button>
                  <!-- 已停用 -->
                  <el-button
                    v-show="scope.row.status === 40"
                    type="text"
                    @click="enable(scope.row, 1)"
                    style="font-size: 16px"
                  >
                    启用
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryParams.page"
            :page-size="queryParams.limit"
            layout="total,sizes, prev, pager, next, jumper"
            :total="totalVal"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 停用弹窗 -->
    <Dialog
      title="停用提示"
      :visible="dialogVisibleArray.stopVisible"
      width="400px"
      @submitPopupData="sureStop"
      @resetPopupData="closeDialog"
      @handleClose="closeDialog"
    >
      <template slot>
        <div class="hintBox">停用后将关闭该机构相关账号所有权限，确认停用吗？</div>
      </template>
    </Dialog>
    <!-- 退回申请弹窗 -->
    <Dialog
      title="退回申请"
      :visible="dialogVisibleArray.returnVisible"
      width="400px"
      @submitPopupData="sureReturn"
      @resetPopupData="ReturnCloseDialog"
      @handleClose="ReturnCloseDialog"
    >
      <template slot>
        <div class="hintBox">退回后该申请状态将变成待审核，确认退回吗？</div>
      </template>
    </Dialog>
    <!-- 启用弹窗 // 签约审核通过弹窗 -->
    <Dialog
      :title="titleVal"
      :visible="dialogVisibleArray.enableVisible"
      width="400px"
      :disabledval="!expireDate"
      @submitPopupData="enableReturn"
      @resetPopupData="EnableCloseDialog"
      @handleClose="EnableCloseDialog"
    >
      <template slot>
        <div style="margin: 0 12px">
          <el-date-picker
            v-model="expireDate"
            value-format="yyyy-MM-dd"
            placeholder="请设置到期时间"
            :picker-options="pickerOptions0"
          ></el-date-picker>
        </div>
      </template>
    </Dialog>
    <!-- 审核  -- 拒绝 -->
    <Dialog
      title="拒绝申请"
      :visible="dialogVisibleArray.refuseVisible"
      width="400px"
      :disabledval="!textarea"
      @submitPopupData="refuseReturn"
      @resetPopupData="refuseCloseDialog"
      @handleClose="refuseCloseDialog"
    >
      <template slot>
        <div class="pass-box">
          <el-input
            type="textarea"
            placeholder="请填写拒绝原因"
            v-model="textarea"
            maxlength="50"
            show-word-limit
          ></el-input>
        </div>
      </template>
    </Dialog>
    <!-- 图片查看器 -->
    <picture-view
      v-if="dialogTableVisible"
      :on-close="closeViewer"
      :url-list="imageUrlList"
      :showpage="false"
    ></picture-view>
  </div>
</template>
<script>
//  引用 table静态资源
import ProvinceCityArea from '@/components/province-city-area/province-city-area';
import Dialog from '../../components/allergan-dialog/index.vue';
import pictureView from '../../components/image-view/index';
import { ContractList, ContractEdit } from '../../api/allerganApi';
import { parseTime } from '@/utils/time.js';
const { buttonList, tableData, dialogVisibleArray, parmslist } = require('./index');
export default {
  name: 'InstitutionalManagement',
  components: {
    ProvinceCityArea, // 地区选择组件
    pictureView,
    Dialog, // 弹窗组件
  },
  data() {
    return {
      // 禁止选择当前之前的时间
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      filter_date: [], //  更新时间
      tableData, // 表格数据
      totalVal: 1, // 数据总条数
      tableLoading: false, // 是否展示加载状态
      buttonList, // 按钮列表
      queryParams: {
        page: 1, // 当前页数
        limit: 10, // 每页条数
        cityName: '', // 市编码
        provinceName: '', // 省编码
        status: '', // 状态
        keyWord: '', // 关键字
        startUpdatedAt: '', // 更新开始时间
        endUpdatedAt: '', // 更新结束时间
      }, // 列表接口请求参数
      dialogVisibleArray, // 控制弹窗是否展示
      imageUrlList: [], // 图片地址
      dialogTableVisible: false, // 图片预览器是否展示
      expireDate: '', // 启动操作-到期时间
      textarea: '', // 审核拒绝原因
      parmslist, // 编辑参数
      titleVal: '启用设置', // 启用弹窗/通过弹窗标题
      activeName: '0', // 状态选择栏默认选中值
    };
  },
  created() {
    this.getList();
  },
  methods: {
    parseTime,
    // 头部筛选条件点击事件
    chouseStatusAction(val) {
      this.queryParams.status = val;
      this.getList();
    },
    // 省市区回调 {province, city, area}
    provinceCityAreaEmit(e) {
      this.queryParams.provinceName = e.province;
      this.queryParams.cityName = e.city;
    },
    // 更新时间选择事件
    dataTimeChangeAction() {
      if (Array.isArray(this.filter_date)) {
        const startUpdatedAt = this.filter_date[0];
        const endUpdatedAt = this.filter_date[1];
        this.queryParams.startUpdatedAt = this.dateToMs(`${startUpdatedAt} 00:00:00`);
        this.queryParams.endUpdatedAt = this.dateToMs(`${endUpdatedAt} 23:59:59`);
      } else {
        this.queryParams.startUpdatedAt = '';
        this.queryParams.endUpdatedAt = '';
      }
    },
    // 转时间戳
    dateToMs(date) {
      const result = new Date(date).getTime();
      return result / 1000;
    },
    // 筛选按钮事件
    onSubmit() {
      this.queryParams.page = 1;
      this.getList();
    },
    // 重置搜索条件
    reset() {
      const { status } = this.queryParams;
      this.queryParams = {
        page: 1, // 当前页数
        limit: 20, // 每页条数
        cityName: '', // 市编码
        provinceName: '', // 省编码
        keyWord: '', // 关键字
        status, // 状态
        startUpdatedAt: '', // 更新开始时间
        endUpdatedAt: '', // 更新结束时间
      };
      this.filter_date = [];
      this.$refs.ityAarea.provinceClear();
      this.getList();
    },
    // 页码改变
    handleCurrentChange(page) {
      this.queryParams.page = page;
      this.getList(1);
    },
    // 每页条数改变
    handleSizeChange(val) {
      this.queryParams.limit = val;
      this.getList();
    },
    // 获取列表信息
    getList(val) {
      console.log(this.queryParams, 222);
      const { page } = this.queryParams;
      this.queryParams.page = val ? page : 1;
      this.tableLoading = true;
      ContractList(this.queryParams)
        .then((res) => {
          const data = res?.data;
          this.tableData = data;
          this.totalVal = res?.total;
          this.tableLoading = false;
        })
        .catch((res) => {
          console.log(res);
          this.tableLoading = false;
        });
    },
    // 查看协议详情
    viewAgreement(row) {
      this.dialogTableVisible = true;
      this.imageUrlList = [row.fileUrl];
    },
    // 图片预览关闭事件
    closeViewer() {
      this.imageUrlList = [];
      this.dialogTableVisible = false;
    },
    // 签约审核--拒绝
    AuditRefuse(row) {
      this.dialogVisibleArray.refuseVisible = true;
      this.getneedparms(row);
    },
    // 签约审核--拒绝确认
    refuseReturn() {
      const parms = {
        applyNo: this.parmslist.applyNo,
        auditMsg: this.textarea,
        status: 30,
      };
      ContractEdit(parms)
        .then((res) => {
          console.log(res);
          this.$message({
            message: '已拒绝',
            type: 'success',
          });
          this.getList();
        })
        .catch((res) => {
          console.log(res);
        });
      this.refuseCloseDialog();
    },
    // 签约审核 --拒绝--关闭事件
    refuseCloseDialog() {
      this.dialogVisibleArray.refuseVisible = false;
      this.resetParmslist();
    },
    // 退回申请
    returnApplication(row) {
      this.dialogVisibleArray.returnVisible = true;
      this.getneedparms(row);
    },
    // 确认退回事件
    sureReturn() {
      const parms = {
        applyNo: this.parmslist.applyNo,
        status: 10,
      };
      ContractEdit(parms)
        .then((res) => {
          console.log(res);
          this.$message({
            message: '已退回',
            type: 'success',
          });
          this.getList();
        })
        .catch((res) => {
          console.log(res);
        });
      this.ReturnCloseDialog();
    },
    // 退回弹窗关闭
    ReturnCloseDialog() {
      this.dialogVisibleArray.returnVisible = !this.dialogVisibleArray.returnVisible;
      this.resetParmslist();
    },
    // 启用事件
    enable(row, type) {
      this.titleVal = type ? '启用设置' : '通过申请';
      this.dialogVisibleArray.enableVisible = true;
      this.getneedparms(row);
    },
    // 确认启用事件
    enableReturn() {
      const timestamp = this.dateToMs(`${this.expireDate} 23:59:59`);
      const parms = {
        applyNo: this.parmslist.applyNo,
        status: 20,
        endTime: timestamp ? timestamp : '',
      };
      ContractEdit(parms)
        .then((res) => {
          console.log(res);
          this.$message({
            message: this.titleVal === '启用设置' ? '启用成功' : '审核通过',
            type: 'success',
          });
          this.getList();
        })
        .catch((res) => {
          console.log(res);
        });
      this.EnableCloseDialog();
    },
    // 启用弹窗关闭事件
    EnableCloseDialog() {
      this.dialogVisibleArray.enableVisible = false;
      this.resetParmslist();
    },
    // 停用事件
    deactivate(row) {
      this.dialogVisibleArray.stopVisible = true;
      this.getneedparms(row);
    },
    // 确定停用事件
    sureStop() {
      const parms = {
        applyNo: this.parmslist.applyNo,
        status: 40,
      };
      ContractEdit(parms)
        .then((res) => {
          console.log(res);
          this.$message({
            message: '已停用',
            type: 'success',
          });
          this.getList();
        })
        .catch((res) => {
          console.log(res);
        });
      this.closeDialog();
    },
    // 弹窗关闭事件
    closeDialog() {
      this.dialogVisibleArray.stopVisible = !this.dialogVisibleArray.stopVisible;
      this.resetParmslist();
    },
    // 前往医院详情
    goHospitalDetial(row) {
      // this.g_tourl(`/saas/setUp/hospitalManagement/hospitalDetail.html?id=${row.hospital_id}`);
      this.$router.push({
        name: 'hospitalDetail',
        query: {
          id: row.orgId,
          type: '1',
        },
      });
    },
    // 点击操作按钮获取相应参数
    getneedparms(val) {
      this.parmslist.applyNo = val.applyNo;
    },
    // 重置编辑参数
    resetParmslist() {
      this.parmslist = {
        applyNo: '', // 申请编号
      };
      this.textarea = ''; // 拒绝原因
      this.expireDate = '';
    },
  },
};
</script>
<style scoped lang="scss">
@import './index.scss';
</style>
